import { jsx as _jsx } from "react/jsx-runtime";
import Frame from '../frame/index.js';
import Icon from '../icon/index.js';
function FramedIcon({ name, size = 24, shape = 'circle', forceLight = false, className, }) {
    // TODO: This won't be needed once we have final icons.
    const iconSizeFactor = name === 'caret-left' ? 0.75 : 0.67;
    return (_jsx(Frame, { size: size, shape: shape, forceLight: forceLight, className: className, children: _jsx(Icon, { name: name, size: size * iconSizeFactor }) }));
}
export default FramedIcon;
